module.exports = __webpack_public_path__ + "img/q-6-1@2x.514fcb53.png";